// extracted by mini-css-extract-plugin
export var circle = "_2s-2";
export var icon = "_2s-a";
export var iconHighlight = "_2s-0";
export var lg = "_2s-8";
export var md = "_2s-7";
export var outline = "_2s-4";
export var sm = "_2s-6";
export var square = "_2s-1";
export var xl = "_2s-9";
export var xs = "_2s-5";
export var xxs = "_2s-3";